import React from "react";
import { useTranslation } from "react-i18next";

import { img_event, img_sponsor, img_event1, img_snapapp } from "@/constants/imagesUrl";
import SHeading from "@/components/atoms/SHeading";
import EventCard from "@/components/molecules/EventCard";
const EventAndRewards = () => {
  const { t } = useTranslation();
  return (
    <div className="bg-primary-light py-12 mb-8">
      <SHeading
        text={t("home.event_and_rewards.title")}
        className="flex justify-center font-bold md:text-3xl text-xl mb-8"
      />
      <div className="container grid grid-cols-1 md:grid-cols-2 gap-4 mx-auto">
        <EventCard
          data={img_sponsor}
          title={t("home.event_and_rewards.sponsor_title")}
          description={t("home.event_and_rewards.sponsor_description")}
        />
        <EventCard
          data={img_event}
          title={t("home.event_and_rewards.event_title")}
          description={t("home.event_and_rewards.event_description")}
        />
        <EventCard
          data={img_event1}
          title={t("home.event_and_rewards.event1_title")}
          description={t("home.event_and_rewards.event1_description")}
        />
        <EventCard
          data={img_snapapp}
          title={t("home.event_and_rewards.snapapp_title")}
          description={t("home.event_and_rewards.snapapp_description")}
        />
      </div>
    </div>
  );
};

export default EventAndRewards;
